import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as API from '../api';

const userDatasetSlice = createSlice({
  name: 'userDatasetSlice',
  initialState: {
    isFetching: false,
    data: [],
    error: null,
  },
  reducers: {
    userDatasetOperationFailed: (store, action) => {
      store.error = typeof action.payload === 'string' ? action.payload : JSON.stringify(action.payload);
      store.isFetching = false;
    },
    userDatasetRequestFinished: (store, action) => {
      store.data = action.payload;
      store.isFetching = false;
      store.error = null;
    },
    userDatasetOperationFinished: (store) => {
      store.data = [];
      store.isFetching = false;
      store.error = null;
    },
    userDatasetOperationRequested: (store) => {
      store.isFetching = true;
      store.error = null;
    },
  },
});

export const { userDatasetOperationFailed, userDatasetOperationRequested, userDatasetOperationFinished, userDatasetRequestFinished } = userDatasetSlice.actions;
export default userDatasetSlice.reducer;

export const fetchUserDatasets = createAsyncThunk('user/datasets', async ({ customerId, subjectId }, { dispatch }) => {
  try {
    dispatch(userDatasetOperationRequested());
    const {
      data: { datasets },
    } = await API.fetchUserDatasets(customerId, subjectId);
    dispatch(userDatasetRequestFinished(datasets));
  } catch (error) {
    dispatch(userDatasetOperationFailed(error));
  }
});

export const transferUserDatasets = createAsyncThunk('user/datasets', async ({ customerId, recipientCustomerId, ownerSubjectId, recipientSubjectId }, { dispatch }) => {
  try {
    dispatch(userDatasetOperationRequested());
    const data = await API.transferDatasetsBySubjectId(customerId, recipientCustomerId, ownerSubjectId, recipientSubjectId);
    dispatch(userDatasetOperationFinished(data));
  } catch (error) {
    dispatch(userDatasetOperationFailed(error));
  }
});

export const deleteDatasetsBySubjectId = createAsyncThunk('user/datasets', async ({ customerId, subjectId }, { dispatch }) => {
  try {
    dispatch(userDatasetOperationRequested());
    const data = await API.deleteDatasetsBySubjectId(customerId, subjectId);
    dispatch(userDatasetOperationFinished());
  } catch (error) {
    dispatch(userDatasetOperationFailed(error));
  }
});
